import React from "react";
import { Shield, Star, Clock, Users, Award } from "lucide-react";

/**
 * TrustBar — a thin strip of credibility signals that sits just below the
 * hero. Uses inline separators + subtle icons rather than badges/cards so
 * it reads as one editorial line rather than a marketing sticker.
 *
 * Numbers are intentionally hard-coded (updated when the underlying
 * business milestones change) so the strip loads instantly with no
 * request.
 */
const SIGNALS = [
  { icon: Shield, label: "100% Halal", detail: "Certified kitchen" },
  { icon: Star,   label: "4.9★ Google", detail: "38 verified reviews" },
  { icon: Clock,  label: "15–20 min",   detail: "Ready for takeaway" },
  { icon: Award,  label: "Family-owned", detail: "Since 2019" },
  { icon: Users,  label: "Kids welcome", detail: "$10 Kids Combo" },
];

export default function TrustBar() {
  return (
    <section
      className="bg-[var(--mm-charcoal)] border-y border-[var(--mm-line)]"
      data-testid="trust-bar"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 md:px-12 py-4">
        <ul className="flex flex-nowrap overflow-x-auto md:overflow-visible md:justify-between items-center gap-6 md:gap-4 no-scrollbar">
          {SIGNALS.map(({ icon: Icon, label, detail }) => (
            <li
              key={label}
              className="flex items-center gap-3 shrink-0"
              data-testid={`trust-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <Icon size={16} className="text-[var(--mm-accent)] shrink-0" strokeWidth={1.5} />
              <div className="whitespace-nowrap">
                <p className="text-[13px] font-medium tracking-wide text-[var(--mm-cream)] leading-tight">
                  {label}
                </p>
                <p className="text-[10px] uppercase tracking-[0.24em] text-[var(--mm-cream)]/50 leading-tight mt-0.5">
                  {detail}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
